// Automatically generated based off shared.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package com.crowpay.notifications

import com.lightningkite.UUID
import com.lightningkite.lightningdb.*
import com.lightningkite.serialization.DataClassPath
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlin.time.Duration.Companion.minutes
import com.lightningkite.serialization.*
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer
import com.lightningkite.*

// Contextual types: 
fun prepareUserEventTypeFields() {
    UserEventType.serializer(NothingSerializer()).properties { args -> arrayOf(
        UserEventType_user(args[0]),
        UserEventType_type(args[0]),
    ) }
}
inline val <ROOT, UID: Comparable<UID>> DataClassPath<ROOT, UserEventType<UID>>.user: DataClassPath<ROOT, UID> get() = this.serializer.tryTypeParameterSerializers()!!.let { this[UserEventType_user(it[0] as KSerializer<UID>)] }
inline val <ROOT, UID: Comparable<UID>> DataClassPath<ROOT, UserEventType<UID>>.type: DataClassPath<ROOT, EventType> get() = this.serializer.tryTypeParameterSerializers()!!.let { this[UserEventType_type(it[0] as KSerializer<UID>)] }


class UserEventType_user<UID: Comparable<UID>>(uID: KSerializer<UID>): SerializableProperty<UserEventType<UID>, UID> {
    override val name: String by lazy { UserEventType.serializer(NothingSerializer()).descriptor.getElementName(0) }
    override fun get(receiver: UserEventType<UID>): UID = receiver.user
    override fun setCopy(receiver: UserEventType<UID>, value: UID) = receiver.copy(user = value)
    override val serializer: KSerializer<UID> by lazy { (UserEventType.serializer(uID) as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UID> }
    override val annotations: List<Annotation> by lazy { UserEventType.serializer(uID).descriptor.getElementAnnotations(0) }
    override fun hashCode(): Int = -1388994850
    override fun equals(other: Any?): Boolean = other is UserEventType_user<* >
}
class UserEventType_type<UID: Comparable<UID>>(uID: KSerializer<UID>): SerializableProperty<UserEventType<UID>, EventType> {
    override val name: String by lazy { UserEventType.serializer(NothingSerializer()).descriptor.getElementName(1) }
    override fun get(receiver: UserEventType<UID>): EventType = receiver.type
    override fun setCopy(receiver: UserEventType<UID>, value: EventType) = receiver.copy(type = value)
    override val serializer: KSerializer<EventType> by lazy { (UserEventType.serializer(uID) as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<EventType> }
    override val annotations: List<Annotation> by lazy { UserEventType.serializer(uID).descriptor.getElementAnnotations(1) }
    override fun hashCode(): Int = -1389729457
    override fun equals(other: Any?): Boolean = other is UserEventType_type<* >
}
